import {FormSetup} from "../models/definitions/FormSetup";
import {QuestionSetup} from "../models/definitions/QuestionSetup";

export class DynamicFormsSetupEditorData<T extends FormSetup | QuestionSetup> {
	constructor(
		readonly setup: T,
		readonly originalSetup: T,
		readonly parentData: DynamicFormsSetupEditorData<T> | null,
		readonly isDeleted: boolean,
		readonly isNew: boolean,
	) {
	}
	
	copy({
		setup,
		originalSetup,
		parentData,
		isDeleted,
		isNew,
	}: {
		setup?: T;
		originalSetup?: T;
		parentData?: DynamicFormsSetupEditorData<T> | null;
		isDeleted?: boolean;
		isNew?: boolean;
	} = {}): DynamicFormsSetupEditorData<T> {
		return new DynamicFormsSetupEditorData(
			setup === undefined ? this.setup : setup,
			originalSetup === undefined ? this.originalSetup : originalSetup,
			parentData === undefined ? this.parentData : parentData,
			isDeleted === undefined ? this.isDeleted : isDeleted,
			isNew === undefined ? this.isNew : isNew,
		);
	}
}
